import axios from "axios";

const baseUrl = `${process.env.REACT_APP_BASE_URL}`;

// Add token helper function
const getValidToken = () => {
    try {
        const tokenData = localStorage.getItem("eko-360-p2-token");
        if (!tokenData) return null;

        // Handle both stringified and raw tokens
        const parsedToken = typeof tokenData === 'string' ?
            JSON.parse(tokenData) :
            tokenData;

        return parsedToken.token || parsedToken.access_token || parsedToken;
    } catch (e) {
        console.error("Token parsing error:", e);
        return null;
    }
};

export const createIndicator = async (indicator, token) => {
    try {
        const { data } = await axios.post(`${baseUrl}/indicators`, indicator, {
            headers: { "Content-Type": "application/json", 
                Authorization: `${token}` }
        });
        return data.data; // Returns the created indicator with uuid
    } catch (error) {
        throw error.response?.data?.message || error.message;
    }
};

export const fetchAllIndicators = async (token = null) => {
    token = token || getValidToken();
    console.log("Fetching indicators with token:", token); // Debug

    try {
        const { data } = await axios.get(`${baseUrl}/indicators`, {
            headers: token ? {
                "Content-Type": "application/json",
                Authorization: `${token}`
            } : {}
        });
        
        return data.data?.allIndicators || [];
    } catch (error) {
        
        throw error.response?.data?.message || error.message;
    }
};

export const fetchAllPublicIndicators = async () => {
    try {
        const { data } = await axios.get(`${baseUrl}/indicators/public`);
        return data.data?.allIndicators || [];
    } catch (error) {
        console.error("Error fetching public indicators:", error);
        return []; // Return empty array instead of throwing error
    }
};

// export const fetchAllPublicIndicators = async (token = null) => {
//     token = token || getValidToken();
//     console.log("Fetching indicators with token:", token); // Debug

//     try {
//         const { data } = await axios.get(`${baseUrl}/indicators/public`, {
//             headers: token ? {
//                 "Content-Type": "application/json",
//             } : {}
//         });
        
//         return data.data?.allIndicators || [];
//     } catch (error) {
        
//         throw error.response?.data?.message || error.message;
//     }
// };

// Similar updates for updatedIndicators and deleteIndicators
export const updatedIndicators = async (indicator, uuid, token) => {
    try {
        const { data } = await axios.patch(`${baseUrl}/indicators/${uuid}`, indicator, {
            headers: {"Content-Type": "application/json",
                 Authorization: `${token}` }
        });
        return data.data;
    } catch (error) {
        throw error.response?.data?.message || error.message;
    }
};

export const deleteIndicators = async (uuid, token) => {
    try {
        const { data } = await axios.delete(`${baseUrl}/indicators/${uuid}`, {
            headers: {"Content-Type": "application/json",
                 Authorization: `${token}` }
        });
        return data.data;
    } catch (error) {
        throw error.response?.data?.message || error.message;
    }
};


// Fuel Data API Functions
export const fetchAllFuels = async (token = null) => {
    token = token || getValidToken();

    try {
        const { data } = await axios.get(`${baseUrl}/fuels/public`, {
            headers: token ? {
                "Content-Type": "application/json",
                Authorization: `${token}`
            } : {
                "Content-Type": "application/json"
            }
        });

        return data.data?.allFuels || [];
    } catch (error) {
        console.error("Error fetching fuels:", error);
        throw error.response?.data?.message || error.message;
    }
};

export const createFuel = async (fuelData, token) => {
    token = token || getValidToken();

    try {
        const { data } = await axios.post(`${baseUrl}/fuels`, fuelData, {
            headers: {
                "Content-Type": "application/json",
                Authorization: `${token}`
            }
        });

        return data.data;
    } catch (error) {
        console.error("Error creating fuel:", error);
        throw error.response?.data?.message || error.message;
    }
};

export const updateFuel = async (fuelData, uuid, token) => {
    token = token || getValidToken();

    try {
        const { data } = await axios.put(`${baseUrl}/fuels/${uuid}`, fuelData, {
            headers: {
                "Content-Type": "application/json",
                Authorization: `${token}`
            }
        });

        return data.data;
    } catch (error) {
        console.error("Error updating fuel:", error);
        throw error.response?.data?.message || error.message;
    }
};

export const deleteFuel = async (uuid, token) => {
    token = token || getValidToken();

    try {
        const { data } = await axios.delete(`${baseUrl}/fuels/${uuid}`, {
            headers: {
                "Content-Type": "application/json",
                Authorization: `${token}`
            }
        });

        return data.data;
    } catch (error) {
        console.error("Error deleting fuel:", error);
        throw error.response?.data?.message || error.message;
    }
};